import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { popoverDriverFactory } from './Popover.driver';
import { Popover, PopoverProps } from '.';
import { Button } from '../Button';
import { waitFor } from '@testing-library/react';

describe('Popover', () => {
  const createDriver = createRendererWithUniDriver(popoverDriverFactory);

  const bootstrap = (props: Partial<PopoverProps> = {}) => {
    return createDriver(
      <Popover placement="top" {...props}>
        <Popover.Element>
          <Button data-hook="trigger-element">Trigger Element</Button>
        </Popover.Element>
        <Popover.Content>
          <span>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit.
            Necessitatibus, ut.
          </span>
        </Popover.Content>
      </Popover>,
    );
  };

  it('should render', async () => {
    const { driver } = bootstrap();
    expect(await driver.exists()).toBe(true);
  });

  it('should pass "aria-describedby" to trigger element', async () => {
    const { driver } = bootstrap();
    const ariaDescribedBy = await driver.getTriggerAriaDescribedBy();

    expect(typeof ariaDescribedBy).toBe('string');
    expect(ariaDescribedBy).toBe((await driver.element()).getAttribute('id'));
  });

  describe('uncontrolled', () => {
    it('should open on click', async () => {
      const { driver } = bootstrap();
      await driver.click();
      // TODO: JB: imho must be true because of differences between @wix/unidriver-jsdom-react-legacy (used by @wix/wix-ui-test-utils/vanilla) and @wix/unidriver-jsdom-react
      expect(await driver.isContentElementExists()).toBeFalsy();
    });

    it('should open on hover', async () => {
      const { driver } = bootstrap();
      expect(await driver.isContentElementExists()).toBeFalsy();
      await driver.mouseEnter();
      expect(await driver.isContentElementExists()).toBeTruthy();
    });
  });

  describe('controlled', () => {
    it('should be open when shown is false', async () => {
      const { driver } = bootstrap({ shown: false });
      expect(await driver.isContentElementExists()).toBeFalsy();
    });

    it('should be open when shown is true', async () => {
      const { driver } = bootstrap({ shown: true });
      await waitFor(async () => {
        expect(await driver.isContentElementExists()).toBeTruthy();
      });
    });
  });
});
